<template>
    <div>
        <modal class="how-to-set" :display="modalStatus.howToSetTaskBonus" @modalStatus="closeModal" >
            <h1>不知道如何設定委託獎金？</h1>
            <div class="how-to-set-wrap">
                <ul>
                    <li>1. 委託獎金最低為租金的20%，付款後將由平台暫時保管至委託時間結束</li>
                    <li>2. 不論委託成功或失敗均須支付平台服務費，費用為委託獎金的20%。委託成功，平台發放80%獎金予受託人，委託失敗平台將退還80%獎金予受委託</li>
                </ul>
                <!-- <div class="content">
                    <div class="list">
                        <span class="title">委託時間是什麼？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文我是說明文。</span>
                    </div>
                    <div class="list">
                        <span class="title">我該如何設定委託時間？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案。</span>
                    </div>
                    <div class="list">
                        <span class="title">我設定的委託時間對房客有什麼影響？</span>
                        <span class="info">我是說明文案我是說明文案，我是說明文案，我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案我是說明文案。</span>
                    </div>
                </div> -->
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'howToSetTaskBonus'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.how-to-set{
        .modal-content{
            width: 448px;
            height: 400px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 288px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto;
                    line-height: 1.5;
                }
                .how-to-set-wrap{
                    padding: 0 32px;
                    ul{
                        li{
                            line-height: 1.5;
                            margin-bottom: 12px;
                        }
                    }
                    .content{
                        margin-bottom: 20px;
                        .list{
                            margin-bottom: 34px;
                            .title{
                                display: block;
                                font-size: 16px;
                                font-weight: 500;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/howToSetTaskBonus.vue